<template lang="html">
  <label
    class="radio-container"
    :class="[checkClasses]"
    @click.prevent="toggleCheck"
  >
    <input type="radio" />
    <span class="radio-checkmark"></span>
  </label>
</template>

<script>
  export default {
    props: {
      model: [String, Boolean, Number],
      value: {
        type: [String, Boolean, Number],
        default: 'on',
      },
      disabled: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    model: {
      prop: 'model',
      event: 'change',
    },
    computed: {
      isSelected() {
        return this.model === this.value;
      },
      checkClasses() {
        return {
          selected: this.isSelected,
          disabled: this.disabled,
        };
      },
    },
    methods: {
      toggleCheck() {
        if (!this.disabled) {
          this.$emit('change', this.value);
        }
      },
    },
  };
</script>

<style scoped lang="stylus">
  /****** Import Global Stylus ******/
  @import '~app/global-stylus'
  /****** Defaults ******/
  /* Customize the label (the container) */
  .radio-container
    display: block
    position: relative
    padding-left: 35px
    margin-bottom: 21px
    font-size: 22px
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    user-select: none
    &:not(.disabled)
      cursor: pointer


  /* Hide the browser's default radio */
  .radio-container input
    position: absolute
    opacity: 0
    left: -999em

  /* Create a custom radio */
  .radio-checkmark
    position: absolute
    top: 0
    left: 0
    height: 20px
    width: 20px
    border: 2px solid pl-slate
    border-radius: 50%
    background-color: #ffffff
    transition: cubic-bezier(.25, .8, .25, 1) .3s

  /* On mouse-over, add a grey background color */
  // .radio-container:hover:not(.selected) > .radio-checkmark
  //   background-color: #eee

  /* When the radio is checked, add a blue background */
  .selected > .radio-checkmark
    background-color: #ffffff
    border: 2px solid pl-slate
    border-radius: 50%

  /* Create the radio-checkmark/indicator (hidden when not checked) */
  .radio-checkmark:after
    content: ""
    position: absolute
    opacity: 0

  /* Show the radio-checkmark when checked */
  .selected > .radio-checkmark:after
    opacity: 1
    transition: cubic-bezier(.25, .8, .25, 1) .6s

  .selected.disabled > .radio-checkmark:after
    opacity: 1
    background-color: pl-slate !important

  /* Style the radio-checkmark/indicator */
  .radio-container .radio-checkmark:after
    left: 3px
    top: 3px
    width: 10px
    height: 10px
    border-radius: 50%
    background-color: pl-primary
</style>



// WEBPACK FOOTER //
// plRadio.vue?7b109555